import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { List } from 'foundations-components/transitional/components/List';
import { Image } from 'foundations-components/transitional/components/Image';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { DEFAULT_SHARING_METHODS } from '../../../../constants/sharingMethods';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useShareViaSettings } from '../ShareViaSettingsContext';
// @ts-expect-error: no types
import { useControlsContext } from '../../../shareAsset/context';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IntegrationsIcon } from 'foundations-assets';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { get } from 'share-with-third-party-component-lib/utils/ConnectionStatusErrorMessageGetter';
import { getSettingsPageUrl } from 'share-with-third-party-component-lib/utils/Url';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SharingMethodStepContent = () => {
  const {
    apps,
    selectedApp,
    setSelectedApp,
    loadingThirdPartyApps
  } = useShareViaSettings();
  const {
    setCurrentDialog
  } = useControlsContext();
  const handleSelectApp = appId => {
    setCurrentDialog(appId);
    setSelectedApp(appId);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H4, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.steps.sharingMethodStep.title"
      })
    }), /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.shareVia.dialog.steps.sharingMethodStep.description"
      })
    }), /*#__PURE__*/_jsx(List, {
      marginBlockStart: "800",
      wrapChildren: true,
      children: apps.map(item => {
        const isDefaultSharingMethod = Boolean(DEFAULT_SHARING_METHODS[item.id]);
        const app = item;
        const isAppDisabled = Boolean(app.connectionStatusTranslatedErrorMessage);
        return /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: get(app.integrationStatus),
            elements: {
              Link
            },
            options: {
              href: getSettingsPageUrl(),
              external: true,
              use: 'on-bright',
              appname: app.name
            }
          }),
          disabled: !isAppDisabled,
          children: /*#__PURE__*/_jsx(SelectableBox, {
            marginBlockEnd: "400",
            name: `application-${app.name}`,
            "data-test-id": `share-application-${app.name}`,
            selected: app.id === selectedApp,
            onClick: () => handleSelectApp(app.id),
            disabled: isAppDisabled,
            type: "default",
            inlineSize: "100%",
            children: /*#__PURE__*/_jsxs(TFlex, {
              direction: "row",
              align: "center",
              justify: "between",
              children: [isDefaultSharingMethod ? /*#__PURE__*/_jsx(Illustration, {
                name: app.iconName,
                inlineSize: "55px"
              }) : app.applicationAssetsResponse.extensionIconUrl ? /*#__PURE__*/_jsx(Image, {
                src: app.applicationAssetsResponse.extensionIconUrl,
                inlineSize: "36px"
              }) : /*#__PURE__*/_jsx(IconHolder, {
                icon: IntegrationsIcon,
                margin: "-100",
                color: "fill-tertiary-pressed",
                size: "850",
                padding: "0"
              }), /*#__PURE__*/_jsx(H4, {
                textAlign: "left",
                inlineSize: "100%",
                marginBlockEnd: "0",
                marginInlineStart: "600",
                children: item.name
              }), /*#__PURE__*/_jsx(RadioInput, {
                checked: item.id === selectedApp,
                defaultChecked: false,
                disabled: isAppDisabled
              })]
            })
          })
        }, app.id);
      })
    }), loadingThirdPartyApps && /*#__PURE__*/_jsx(LoadingDots, {
      minHeight: 200
    })]
  });
};
export default SharingMethodStepContent;